import React, { useState } from 'react';
import { Responsive } from 'vendors/semantic-ui';

import { configUI } from 'config';
import { HtmlContainer } from 'modules/shared-ui/components';
import { TabItem, Tab } from 'modules/shared-ui-advanced/components';

import { Brand, Availability, AvailabilityValues } from '../../../../../models';

import { Props } from './product-details-type';

import styles from './product-details-component.module.css';

const moreThanOneDefined = (specs: string, description: string, brand?: Brand): boolean => {
    return !!(
        (specs && description) ||
        (description && brand && brand.description) ||
        (specs && brand && brand.description) ||
        (specs && description && brand && brand.description)
    );
};

const getAvailability = (availability?: Availability): JSX.Element => {
    switch (availability) {
        case AvailabilityValues.HAUSSMAN_WITH_ORDER:
            return (
                <em>
                    Produit disponible au Printemps Haussmann uniquement. Certaines commandes spéciales sont possibles,
                    pour en connaître les modalités, renseignez-vous auprès de l&apos;Espace Printemps Listes de votre
                    magasin Printemps.
                </em>
            );
        case AvailabilityValues.OTHER_WITH_ORDER:
            return (
                <em>
                    Produit disponible dans certains magasins uniquement. Des commandes spéciales sont possibles, pour
                    en connaître les modalités, renseignez-vous auprès de l&apos;Espace Printemps Listes de votre
                    magasin Printemps.
                </em>
            );
        case AvailabilityValues.HAUSSMAN_WITHOUT_ORDER:
            return <em>Produit disponible au Printemps Haussmann uniquement.</em>;
        case AvailabilityValues.OTHER_WITHOUT_ORDER:
            return <em>Produit disponible dans certains magasins uniquement.</em>;
        case AvailabilityValues.MID:
            return (
                <em>
                    Produit disponible sur commande à l&apos;Espace Made in Design de votre magasin Printemps Haussmann,
                    Lille et Lyon.
                </em>
            );
        default:
            return <React.Fragment />;
    }
};

const buildTabs = (specs?: string, description?: string, brand?: Brand): TabItem[] => {
    const result: TabItem[] = [];
    if (specs) {
        result.push({ header: 'Caractéristiques', content: specs });
    }
    if (description) {
        result.push({ header: 'Description', content: description });
    }
    if (brand) {
        result.push({ header: 'Informations Marque', content: brand.description });
    }
    return result;
};

export const ProductDetails: React.FC<Props> = (props: Props) => {
    const { specs, availability, description, brand } = props;
    const showBtn = moreThanOneDefined(specs, description, brand);
    const [textHidden, setTextHidden] = useState(showBtn);

    const handleClick: () => void = () => setTextHidden(!textHidden);
    if (props) {
        return (
            <React.Fragment>
                <Responsive as={React.Fragment} minWidth={configUI.responsive.tablet.minWidth}>
                    <div className={styles.container}>
                        <div className={`${styles.textContainer} ${textHidden ? styles.hidden : ''}`}>
                            {specs && (
                                <React.Fragment>
                                    <div className={styles.column} />
                                    <span className={styles.separator} />
                                </React.Fragment>
                            )}

                            <div className={styles.column}>
                                <span className={styles.columnTitle}>Description Produit</span>
                                <div className={styles.columnContent}>
                                    {description && (
                                        <HtmlContainer style={{ display: 'block' }} htmlContent={description} />
                                    )}
                                    {description && !!availability && <br />}
                                    {!!availability && <div>{getAvailability(availability)}</div>}
                                </div>
                            </div>
                            {brand && brand.description && (
                                <React.Fragment>
                                    <span className={styles.separator} />
                                    <div className={styles.column}>
                                        <span className={styles.columnTitle}>Informations marque</span>
                                        <div className={styles.columnContent}>
                                            <HtmlContainer htmlContent={brand.description} />
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                        {showBtn && (
                            <button type="button" className={styles.btnExpand} onClick={handleClick}>
                                {textHidden ? 'Plus de détails' : 'Moins de détails'}
                            </button>
                        )}
                    </div>
                </Responsive>
                <Responsive as={React.Fragment} maxWidth={configUI.responsive.mobile.maxWidth}>
                    <Tab items={buildTabs(specs, description, brand)} />
                </Responsive>
            </React.Fragment>
        );
    }
    return <React.Fragment></React.Fragment>;
};
